import { Component } from "preact";

import SearchHelpCenter from "./../../SearchHelpCenter";
import PGFeedbackIcon from "../../../assets/icons/PGFeedbackIcon";

import layoutStyle from "./../../App/layout.scss";
import style from "./index.scss";
import { getRedirect } from "../../../api";
import { clickOnLink } from "../../../utils/eventHandlers";
import { Button } from "./../../Helpers";
import PGBackIcon from "../../../assets/icons/PGBackIcon";

export default class Home extends Component {
  render({ onContentClick, payload, type }) {
    const { isClientAdmin, isStandardHub } = payload;
    return (
      <div>
        <div class={layoutStyle.container}>
          {type !== 'showButtons'
            ? <SearchHelpCenter
              onContentClick={onContentClick}
              payload={payload}
              isBackButton={false}
            />
            :
            <div className={style.additionalButton}>
            <button
              tabIndex="0"
              aria-label="Go Back"
              class={style.backButton}
              onClick={() => onContentClick()}
            >
              <PGBackIcon />
            </button>
              <p className={style.actionTitle}>
                Didn't find what you were looking for?
              </p>
              <div className={style.btnGroup}>
                <Button
                  onClick={() => onContentClick("ReportIssueV2")}
                  className={style.actionButton}
                >
                  Submit a Support Ticket
                </Button>
                <Button
                  type="secondary"
                  onClick={() =>
                    onContentClick("featureRequest")
                  }
                  className={style.actionButton}
                >
                  Submit a Feature Idea
                </Button>
              </div>
            </div>}
        </div>
        <div class={layoutStyle.containerFooter}>
          {isClientAdmin && !isStandardHub && (
            <div className={style.feedbackContainer}>
              <PGFeedbackIcon />
              <p className={style.feedbackMessage}>
                Have questions for other partners? Ask them in the
                <a
                  href="https://community.peoplegrove.com"
                  target="_blank"
                  className={style.feedbackLink}
                >
                  PeopleGrove Community
                </a>
                .
              </p>
            </div>
          )}
          <div className={style.accessTicketsContainer}>
            <a
              class={style.accessTicketLink}
              onClick={() =>
                getRedirect({
                  queryStr: "https://support.peoplegrove.com/hc/en-us/requests",
                  payload,
                })
              }
              role="button"
              tabIndex="0"
              onKeyDown={clickOnLink}
            >
              Access all your tickets here.
            </a>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./components/User/UserHome/index.js